import { render, staticRenderFns } from "./SpellingDictionaries.vue?vue&type=template&id=50de5e4c&scoped=true"
import script from "./SpellingDictionaries.vue?vue&type=script&lang=ts"
export * from "./SpellingDictionaries.vue?vue&type=script&lang=ts"
import style0 from "./SpellingDictionaries.vue?vue&type=style&index=0&id=50de5e4c&prod&lang=scss&scoped=true"
import style1 from "./SpellingDictionaries.vue?vue&type=style&index=1&id=50de5e4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50de5e4c",
  null
  
)

export default component.exports